import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// 语言资源
import en from "./locales/en";
import zh from "./locales/zh";
import vi from "./locales/vi";
// 默认语言
export const defaultLanguage = "vi";
export const supportedLanguages = [
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "zh", name: "中文", flag: "🇨🇳" },
    { code: "vi", name: "Tiếng Việt", flag: "🇻🇳" },
];
// 自动扫描命名空间
const scanNamespaces = (langModule) => {
    const namespaces = [];
    for (const key in langModule) {
        if (langModule[key] && typeof langModule[key] === "object") {
            namespaces.push(key);
        }
    }
    return namespaces;
};
// 自动构建资源对象
const buildResources = (langModule) => {
    const resources = {};
    for (const key in langModule) {
        if (langModule[key] && typeof langModule[key] === "object") {
            resources[key] = langModule[key];
        }
    }
    return resources;
};
// 获取所有可用的命名空间（取并集）
const getAllNamespaces = () => {
    const enNamespaces = scanNamespaces(en);
    const zhNamespaces = scanNamespaces(zh);
    const viNamespaces = scanNamespaces(vi);
    // 取所有语言的命名空间并集
    const allNamespaces = new Set([
        ...enNamespaces,
        ...zhNamespaces,
        ...viNamespaces,
    ]);
    return Array.from(allNamespaces);
};
i18n.use(initReactI18next).init({
    // 初始语言 - 微前端场景，由主项目传递
    lng: defaultLanguage,
    // 回退语言
    fallbackLng: "vi",
    // 调试模式（开发环境）
    debug: process.env.NODE_ENV === "development",
    // 插值配置
    interpolation: {
        escapeValue: false,
    },
    // 自动扫描命名空间
    ns: getAllNamespaces(),
    defaultNS: "common",
    // 自动构建资源
    resources: {
        en: buildResources(en),
        zh: buildResources(zh),
        vi: buildResources(vi),
    },
});
export default i18n;
